module.exports = __webpack_public_path__ + "media/images/icons/outlined/deployment-unit-ea7cc63f69a89515aed50717e6cbf619.svg";